let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bWZ2H")).then(() => parcelRequire('6yRTH'));